export default __webpack_public_path__ + "static/media/Layer 1.cb9f449c.jpg";